export const ROUTING_NUMBER_PATTERN = /^\d{9}$/;
export const ACCOUNT_NUMBER_PATTERN = /^\d{4,17}$/;
export const ROUTING_NUMBER_LENGTH = 9;
export const ACCOUNT_NUMBER_MAX_LENGTH = 17;
export const PLAID_READY_TIMEOUT_MS = 20_000;
